import React from 'react'
import { css } from '@emotion/react'

import { SUI } from 'shared/ui'
import Scroller from 'components/Scroller'
import NewTicketFAB from 'components/App/DesktopView/Layout/NewTicketFAB'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import TicketList from 'subapps/ticketing/components/TicketList'
import TicketListHeader from 'subapps/ticketing/components/TicketList/Header'
import styles from './styles.less'

// Wraps the ticket list container and adds mouseEnter/Leave events
export default function WrappedTicketList({
  hasSearchErrored,
  isQueryStringValid,
  listTitle,
  queryString,
  ticketIds,
}) {
  return (
    <div className={styles.leftCell}>
      <SUI
        css={css`
          /* Auto-grow SUI wrapper to fill leftCell */
          &,
          & > * {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            min-height: 0px;
          }
        `}
      >
        <TicketListHeader
          isSidebarOpen
          ticketIds={ticketIds}
          title={listTitle}
        />

        {queryString && hasSearchErrored && <SearchErrorMessage />}
        {queryString &&
          !isQueryStringValid &&
          !hasSearchErrored && (
            <Scroller className="desktopNormalScrollbarDisableRightBorder">
              <InvalidSearchMessage queryString={queryString} />
            </Scroller>
          )}
        {(!queryString || (!hasSearchErrored && isQueryStringValid)) && (
          <TicketList />
        )}
        <NewTicketFAB />
      </SUI>
    </div>
  )
}
